import { onStage, permissions, room } from "../../libs/roomnew";

export default class Controls{
    constructor(){
        this.controls={};
        this.showMenuButtonCont;
        this.showMenuToggle;
        this.mouseOver=false;

    };

    createShowMenuButton(){
        if(!permissions.hasControlsMenu()){return}
        this.showMenuToggle=$("<button/>",{
            class:'btn btn-sm',
            html:`<svg style="width:20px; height:20px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3888 5.0264C15.3888 4.3188 15.1078 3.64018 14.6074 3.13984C14.1071 2.63949 13.4284 2.3584 12.7208 2.3584H3.38284C2.67525 2.3584 1.99663 2.63949 1.49628 3.13984C0.995936 3.64018 0.714844 4.3188 0.714844 5.0264C0.714844 5.734 0.995936 6.41261 1.49628 6.91296C1.99663 7.41331 2.67525 7.6944 3.38284 7.6944H12.7208C13.4284 7.6944 14.1071 7.41331 14.6074 6.91296C15.1078 6.41261 15.3888 5.734 15.3888 5.0264ZM14.7218 5.0264C14.7218 5.55709 14.511 6.06604 14.1358 6.4414C13.7605 6.81656 13.2515 7.02733 12.7208 7.0274H3.38284C2.85215 7.02733 2.3432 6.81656 1.96784 6.4414C1.59278 6.066 1.3821 5.55705 1.3821 5.0264C1.3821 4.49574 1.59278 3.9868 1.96784 3.6114C2.3432 3.23624 2.85215 3.02547 3.38284 3.0254H12.7208C13.2515 3.0254 13.7605 3.23606 14.1358 3.61106C14.5111 3.9865 14.7219 4.49559 14.7218 5.0264Z" fill="white"></path> <path d="M3.38234 6.6934C4.30328 6.6934 5.04984 5.94683 5.04984 5.0259C5.04984 4.10496 4.30328 3.3584 3.38234 3.3584C2.46141 3.3584 1.71484 4.10496 1.71484 5.0259C1.71484 5.94683 2.46141 6.6934 3.38234 6.6934Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.714844 11.0293C0.714844 11.7369 0.995936 12.4155 1.49628 12.9159C1.99663 13.4162 2.67525 13.6973 3.38284 13.6973H12.7208C13.4284 13.6973 14.1071 13.4162 14.6074 12.9159C15.1078 12.4155 15.3888 11.7369 15.3888 11.0293C15.3888 10.3217 15.1078 9.64311 14.6074 9.14277C14.1071 8.64242 13.4284 8.36133 12.7208 8.36133H3.38284C2.67525 8.36133 1.99663 8.64242 1.49628 9.14277C0.995936 9.64311 0.714844 10.3217 0.714844 11.0293ZM12.7208 9.36166C12.2857 9.37232 11.8719 9.55268 11.5679 9.86424C11.2639 10.1758 11.0937 10.5939 11.0937 11.0292C11.0937 11.4645 11.2639 11.8825 11.5679 12.1941C11.8719 12.5056 12.2857 12.686 12.7208 12.6967C13.6412 12.6967 14.3885 11.9497 14.3885 11.0293C14.3885 10.109 13.6412 9.36166 12.7208 9.36166Z" fill="white"></path></svg> Controls`
        }).on("click",(e)=>{
            e.preventDefault();
            e.stopPropagation();
            if(this.container.hasClass("animate-menu-show")){
                if($("#tool-box").hasClass("hidden-control-strip")){
                    $(".controls-menu-container").addClass("control-menu-bottom")
                }else {
                    $(".controls-menu-container").removeClass("control-menu-bottom")
                }
                this.hideControlsMenu();
            }else{
                this.container.addClass("animate-menu-show").removeClass("animate-menu-hide")
                this.showControlsMenu();
                if($("#tool-box").hasClass("hidden-control-strip")){
                    $(".controls-menu-container").addClass("control-menu-bottom")
                }else {
                    $(".controls-menu-container").removeClass("control-menu-bottom")
                }
            }
        });
        this.showMenuButtonCont=$("<div/>",{
            class:'controls-show-menu-toggle d-none d-flex justify-content-center align-items-center',
            html:this.showMenuToggle
        });
        console.log("Addong show menu button");
        $("#stripOptionsContent").append(this.showMenuButtonCont);

    };

    createControlsMenu(){
        if(!permissions.hasControlsMenu()){return}
        console.log("Adding kino controls menu")
        let closeBtn=$("<div/>",{
            class:'controls-close-btn',
            html:`<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
            0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
            120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
            3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
            3.12-8.19 0-11.31L193.94 256z"></path>
        </svg>`
        }).on('click',()=>{
            this.hideControlsMenu();
        })
        let controlsMenuTitle=$("<div/>",{
            class:"controls-menu-title",
            html:[`<svg width="480" height="481" viewBox="0 0 480 481" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M144 144.08C179.346 144.08 208 115.426 208 80.0802C208 44.734 179.346 16.0802 144 16.0802C108.654 16.0802 80 44.734 80 80.0802C80 115.426 108.654 144.08 144 144.08Z" fill="#032836"/>
            <path d="M336 304.08C371.346 304.08 400 275.426 400 240.08C400 204.734 371.346 176.08 336 176.08C300.654 176.08 272 204.734 272 240.08C272 275.426 300.654 304.08 336 304.08Z" fill="#032836"/>
            <path d="M240 464.08C275.346 464.08 304 435.426 304 400.08C304 364.734 275.346 336.08 240 336.08C204.654 336.08 176 364.734 176 400.08C176 435.426 204.654 464.08 240 464.08Z" fill="#032836"/>
            <path d="M16 96.0802H65.6C69.2722 114.165 79.0837 130.424 93.3719 142.102C107.66 153.781 125.546 160.16 144 160.16C162.454 160.16 180.34 153.781 194.628 142.102C208.916 130.424 218.728 114.165 222.4 96.0802H464C468.243 96.0802 472.313 94.3945 475.314 91.3939C478.314 88.3933 480 84.3237 480 80.0802C480 75.8367 478.314 71.7671 475.314 68.7665C472.313 65.7659 468.243 64.0802 464 64.0802H222.4C218.728 45.9956 208.916 29.7366 194.628 18.0582C180.34 6.37971 162.454 0 144 0C125.546 0 107.66 6.37971 93.3719 18.0582C79.0837 29.7366 69.2722 45.9956 65.6 64.0802H16C11.7565 64.0802 7.68687 65.7659 4.68629 68.7665C1.68571 71.7671 0 75.8367 0 80.0802C0 84.3237 1.68571 88.3933 4.68629 91.3939C7.68687 94.3945 11.7565 96.0802 16 96.0802V96.0802ZM144 32.0802C153.494 32.0802 162.774 34.8954 170.667 40.1697C178.561 45.444 184.713 52.9405 188.346 61.7114C191.979 70.4822 192.93 80.1334 191.078 89.4445C189.226 98.7556 184.654 107.308 177.941 114.021C171.228 120.734 162.675 125.306 153.364 127.158C144.053 129.01 134.402 128.059 125.631 124.426C116.86 120.793 109.364 114.641 104.089 106.748C98.8152 98.854 96 89.5737 96 80.0802C96 67.3498 101.057 55.1408 110.059 46.1391C119.061 37.1373 131.27 32.0802 144 32.0802V32.0802Z" fill="#B3BEC2"/>
            <path d="M464 224.08H414.4C410.728 205.996 400.916 189.737 386.628 178.058C372.34 166.38 354.454 160 336 160C317.546 160 299.66 166.38 285.372 178.058C271.084 189.737 261.272 205.996 257.6 224.08H16C11.7565 224.08 7.68687 225.766 4.68629 228.766C1.68571 231.767 0 235.837 0 240.08C0 244.324 1.68571 248.393 4.68629 251.394C7.68687 254.395 11.7565 256.08 16 256.08H257.6C261.272 274.165 271.084 290.424 285.372 302.102C299.66 313.781 317.546 320.16 336 320.16C354.454 320.16 372.34 313.781 386.628 302.102C400.916 290.424 410.728 274.165 414.4 256.08H464C468.243 256.08 472.313 254.395 475.314 251.394C478.314 248.393 480 244.324 480 240.08C480 235.837 478.314 231.767 475.314 228.766C472.313 225.766 468.243 224.08 464 224.08ZM336 288.08C326.506 288.08 317.226 285.265 309.333 279.991C301.439 274.716 295.287 267.22 291.654 258.449C288.021 249.678 287.07 240.027 288.922 230.716C290.774 221.405 295.346 212.852 302.059 206.139C308.772 199.426 317.325 194.855 326.636 193.003C335.947 191.15 345.598 192.101 354.369 195.734C363.14 199.367 370.636 205.519 375.911 213.413C381.185 221.306 384 230.587 384 240.08C384 252.811 378.943 265.02 369.941 274.021C360.939 283.023 348.73 288.08 336 288.08V288.08Z" fill="#B3BEC2"/>
            <path d="M464 384.08H318.4C314.728 365.996 304.916 349.737 290.628 338.058C276.34 326.38 258.454 320 240 320C221.546 320 203.66 326.38 189.372 338.058C175.084 349.737 165.272 365.996 161.6 384.08H16C11.7565 384.08 7.68687 385.766 4.68629 388.766C1.68571 391.767 0 395.837 0 400.08C0 404.324 1.68571 408.393 4.68629 411.394C7.68687 414.395 11.7565 416.08 16 416.08H161.6C165.272 434.165 175.084 450.424 189.372 462.102C203.66 473.781 221.546 480.16 240 480.16C258.454 480.16 276.34 473.781 290.628 462.102C304.916 450.424 314.728 434.165 318.4 416.08H464C468.243 416.08 472.313 414.395 475.314 411.394C478.314 408.393 480 404.324 480 400.08C480 395.837 478.314 391.767 475.314 388.766C472.313 385.766 468.243 384.08 464 384.08ZM240 448.08C230.506 448.08 221.226 445.265 213.333 439.991C205.439 434.716 199.287 427.22 195.654 418.449C192.021 409.678 191.07 400.027 192.922 390.716C194.774 381.405 199.346 372.852 206.059 366.139C212.772 359.426 221.325 354.855 230.636 353.003C239.947 351.15 249.598 352.101 258.369 355.734C267.14 359.367 274.636 365.519 279.911 373.413C285.185 381.306 288 390.587 288 400.08C288 412.811 282.943 425.02 273.941 434.021C264.939 443.023 252.73 448.08 240 448.08Z" fill="#B3BEC2"/>
            </svg>
            `,`Controls`,closeBtn]
        });
        this.controlsMenuItems=$("<div/>",{
            class:"controls-menu-items",
        });
        this.controlsMenuHide=$("<div/>",{
            class:'controls-menu-hide',
            html:`<svg width="44" height="15" viewBox="0 0 44 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M43.4261 14.2132L22.2129 1.5L0.999688 14.2132" stroke="#51626a" stroke-width="2" stroke-linecap="round"/>
        </svg>`
        }).on('click',()=>{
            this.hideControlsMenu();
        })
        let controlsWrapper=$("<div/>",{
            class:"controls-menu-wrapper",
            html:[controlsMenuTitle,this.controlsMenuItems,this.controlsMenuHide]
        })
        const isControlStripHidden = $("#tool-box").hasClass("hidden-control-strip")
        // console.log("NA KUROV", isControlStripHidden);
        this.container=$("<div/>",{
            class:"controls-menu-container animate-menu-hide",
            html:[controlsWrapper]
        }).on('mouseover',(e)=>{
            this.mouseOver=true;
        }).on('mouseleave',(e)=>{
            this.mouseOver=false;
        });
        $("body").append(this.container);

        // this.registerControl('mute-all',muteParticipants.muteIcon,'Mute All - On',"switch",true,(el)=>{
        //     console.log("control clicked",el)
        //     $(el).prop('checked', false);
        // });
        // this.registerControl('lock-focus',lockFocus.lockFocusIcon,'Lock Focus',"switch",true,(el)=>{
        //     console.log("control clicked",el)
        //     $(el).prop('checked', false);
        // });
        this.createShowMenuButton();
    };

    registerControl(id,controlIcon,controlText,controlAction="switch",checkedOrButtonName=false,onClick=false){
        console.log("registering control",id)
        if(id=='mute-all' || id=="mute-on-join"){
            if(!permissions.hasMuteAll()){return}
        }else if(id=='mute-lock'){
            if(!permissions.hasMuteLock()){return}
        }else if(id=='lock-focus'){
            if(!permissions.hasSpacesLock()){return}
        }
        if(this.controls[id]){return}
        let controlItemIcon=$("<div/>",{
            class:"control-item-icon",
            html:controlIcon,
        });

        let controlItemText=$("<div/>",{
            class:"control-item-text",
            html:controlText
        });

        let controlItemInfo=$("<div/>",{
            class:"control-item-info",
            html:[controlItemIcon,controlItemText]
        });
        let controlItemAction=$("<div/>",{
            class:"control-item-action kino-toggle",
        });
        let switchaction;
        if(controlAction=="switch"){
            switchaction=this.buildSwitch(id,checkedOrButtonName);
            controlItemAction.html(switchaction);
            controlItemAction.on('click',(e)=>{
                e.preventDefault()
                e.stopPropagation();
                    if(onClick){
                        if(!this.controls[id].hasClass('control-disabled')){
                            onClick($(`#control-checkbox-${id}`));
                        }
                    }
            });
        }else if(controlAction=="button"){
            switchaction=this.buildButton(id,checkedOrButtonName);
            controlItemAction.html(switchaction);
            switchaction.on('click',(e)=>{
                e.preventDefault()
                e.stopPropagation();
                    if(onClick){
                        if(!this.controls[id].hasClass('control-disabled')){
                            onClick(switchaction);
                        }
                    }
            });
        }
        let stageActive=false;
        try {
            stageActive=onStage && onStage.isActive();
        } catch (error) {

        }
        this.controls[id]=$("<div/>",{
            class:`control-menu-item ${stageActive ? 'control-disabled' :'' }`,
            html:[controlItemInfo,controlItemAction]
        });
        this.controlsMenuItems.append(this.controls[id]);
    };
    toggleSwitch(id,checked){
        try {
            $(`#control-checkbox-${id}`).prop('checked',checked);
        } catch (error) {

        }
    };
    buildSwitch(id,checked=false){
        let flipLocalVideoInput = $('<input/>',{
            id:`control-checkbox-${id}`,
            type: 'checkbox',
            checked: checked
        })
        let flipLocalVideoSwitch = $('<span/>',{
            class: 'kino-slider round',
        })
        return $('<label/>',{
            class: 'switch pe-none',
            html: [flipLocalVideoInput, flipLocalVideoSwitch]
        });
    };

    buildButton(id,name){
        return $('<button/>',{
            class:`btn control-button control-button-${id}`,
            id:`control-button-${id}`,
            html:name
        });
    };

    disableAction(id){
        try {
            if(this.controls[id]){
                this.controls[id].addClass('control-disabled');
            }
        } catch (error) {

        }
    };

    enableAction(id){
        try {
            if(this.controls[id]){
                this.controls[id].removeClass('control-disabled');
            }
        } catch (error) {

        }
    };

    showControlsMenu(){
        if(!room || !room.myUserId()){return}
        this.container.addClass("animate-menu-show").removeClass("animate-menu-hide");
        this.showMenuButtonCont.addClass('controls-menu-shown');
    };

    hideControlsMenu(){
        this.showMenuButtonCont.removeClass('controls-menu-shown');
        this.container.addClass("animate-menu-hide").removeClass("animate-menu-show");
    };

    isMod(){
        return ROLE == "moderator" || HOST == 1;
    }

    onModeratorAccessAdded(){
        if(this.container){
            this.container.remove();
            this.container=undefined;
            this.controls={};
        }
        if(this.showMenuButtonCont){
            this.showMenuButtonCont.remove();
            this.showMenuButtonCont=undefined;
        }
        this.createControlsMenu();
        this.showMenuButtonCont.removeClass('d-none');
    };

    onModeratorAccessRemoved(){
        if(this.container){
            this.container.remove();
            this.container=undefined;
            this.controls={};
        }
        if(this.showMenuButtonCont){
            this.showMenuButtonCont.remove();
            this.showMenuButtonCont=undefined;
            this.showMenuToggle=undefined;
        }
    }


};
